module.exports = __webpack_public_path__ + "img/37.f64e4425.jpg";